module.exports = __webpack_public_path__ + "static/media/insta.882d2cfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/insta.png
// module id = 273
// module chunks = 0